module.exports = __webpack_public_path__ + "media/Images/icon-blue-share-o-b9c12312c9f4c46130ca484eb0516f07.svg";